import React, { useEffect, useState } from "react";

import { useDebounce } from "../../../hooks/useDebounce";
import { useGetExports } from "../../../lib/queries/queriesAndMutations";
import Pagination from "../../Pagination";
import Loader from "../../shared/Loader";
import Button from "../../ui/Button";
import ExportCard from "./ExportCard";
import ExportRow from "./ExportRow";

const Exports = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const pageSize = 20;
  const [searchTerm, setSearchTerm] = useState({
    date: "",
    id: "",
    height: "",
  });
  const debouncedQueryParams = useDebounce(searchTerm, 500); // 500ms delay

  const searchHandler = (name, value) => {
    setSearchTerm((prev) => ({ ...prev, [name]: value }));
  };
  const onPageChange = (page) => setCurrentPage(page);

  const { data: exportList, isPending, refetch, isRefetching } = useGetExports({ currentPage, pageSize });

  const list = exportList?.data?.items;
  const hasData = exportList?.data?.count > 0;

  useEffect(() => {
    refetch();
  }, [debouncedQueryParams, refetch, currentPage]);

  if (isPending || isRefetching) {
    return (
      <div className="w-full h-full flex-center">
        <Loader />
      </div>
    );
  }
  return (
    <div className=" w-full  p-2 md:p-6 overflow-y-scroll vanda ">
      <div className="overflow-y-scroll ] no-scrollbar   ">
        <Button
          onClick={() => refetch()}
          className="flex gap-2 items-center bg-neutral-10 shadow-md mr-auto hover:bg-neutral-20"
        >
          <p>به روز رسانی لیست</p>
          <img src="/images/updatelist.svg" alt="" className="w-4 h-4" />
        </Button>
        {hasData ? (
          <div className="mx-auto ">
            <table className="fixed-header  p-4 rounded-lg mx-auto w-fit  hidden md:block " id="export">
              <thead>
                <tr>
                  <th scope="col" className="lg:min-w-[150px]">
                    نوع فایل
                  </th>
                  <th scope="col" className="lg:min-w-[150px]">
                    تاریخ درخواست
                  </th>
                  <th scope="col" className="lg:min-w-[150px]">
                    وضعیت
                  </th>

                  <th scope="col" className="lg:min-w-[150px]">
                    لینک دانلود
                  </th>
                </tr>
              </thead>
              <tbody cellSpacing={"16px"}>
                {list.map((item, index) => {
                  return <ExportRow item={item} />;
                })}
              </tbody>
            </table>
            <div className="md:hidden  p-2 flex flex-col gap-2">
              {list.map((item, index) => {
                return <ExportCard item={item} />;
              })}
            </div>
          </div>
        ) : (
          <div className="flex flex-col min-h-[300px]  m-auto justify-center items-center gap-6">
            <div className="bg-neutral-10 flex flex-col items-center p-6 rounded-md">
              <img src="/images/folder-empty.svg" alt="" className="max-w-[40px] max-h-[40px]" />
              <p> درخواست فعالی وجود ندارد!</p>
            </div>
          </div>
        )}
      </div>
      <div className=" bg-white ">
        <Pagination
          onPageChange={onPageChange}
          totalCount={exportList?.data?.count || 0}
          siblingCount={1}
          currentPage={currentPage}
          pageSize={pageSize}
          className=" "
        />
      </div>
    </div>
  );
};

export default Exports;
